module.exports = __webpack_public_path__ + "static/media/uni.273d0dda.gif";